import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import RULE_ASSIGNMENT_FIELDS from '../../config/rule-assignment-fields.config';

const RuleAssignmentFields = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  validOptions,
  disabled,
  sx,
  error,
}) => (
  <FormControl fullWidth error={error !== ''} variant="filled">
    <InputLabel id={`field-${id}-select-label`}>{label}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id={id}
      name={name}
      value={defaultValue}
      label={label}
      onChange={onChange}
      disabled={disabled}
      sx={sx}
    >
      {validOptions.map((k) => (
        <MenuItem key={`${id}-v-${k}`} value={k}>
          {RULE_ASSIGNMENT_FIELDS[k].label}
        </MenuItem>
      ))}
    </Select>
    {error !== '' && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

RuleAssignmentFields.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  validOptions: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
RuleAssignmentFields.defaultProps = {
  disabled: false,
  sx: {},
  error: '',
};

export default RuleAssignmentFields;
